import { useEffect, useState } from 'react';

import { checkIsPageAccessAuthorized, retrieveUserData, subscribeToSessionChange } from 'services';

const defaultReturnValue = {
  isAuthorized: false,
  isAuthenticated: false,
  userPermissions: [],
  token: null,
  email: null,
};

function useAuth(pagePermissions?: number[]) {
  // Bumped on login/logout so components mounted across that transition
  // (e.g. providers mounted once at the app root) re-read the session cookie.
  const [, forceUpdate] = useState(0);

  useEffect(() => subscribeToSessionChange(() => forceUpdate((n) => n + 1)), []);

  const session = retrieveUserData();

  if (!session) return defaultReturnValue;

  const userPermissions = session.permissions;
  const email = session.email;
  const id = session.id;

  const isAuthorized = checkIsPageAccessAuthorized(pagePermissions ?? [], userPermissions);

  return { isAuthorized, userPermissions, email, isAuthenticated: !!id };
}

export { useAuth };
